const OrgChartIcon = () => (
  <svg style={{ width: 16, height: 'auto' }} viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="5" r="3"/>
    <line x1="12" y1="8" x2="12" y2="14"/>
    <circle cx="6" cy="19" r="3"/>
    <circle cx="18" cy="19" r="3"/>
    <line x1="12" y1="14" x2="6" y2="16"/>
    <line x1="12" y1="14" x2="18" y2="16"/>
  </svg>
);

export default OrgChartIcon;
